<template>
  <div class="w-full md:flex-1 rounded flex flex-col" style="height: 440px">
    <div class="flex justify-between mb-2 items-center">
      <div class="text-sm lg:text-base">
        Rank： Daily Change in DAO Treasuries
      </div>
      <div v-if="state.data.length > 0" class="space-x-2 md:space-x-6 flex">
        <tippy allowHTML :arrow="false" interactive>
          <div
            class="
              w-9
              h-9
              rounded-full
              bg-white-005
              flex
              items-center
              justify-center
              cursor-pointer
              hover:bg-white-030
              transition-all
            "
          >
            <i class="iconfont icon-xiazai text-xs"></i>
          </div>

          <template #content
            ><div class="space-y-2 px-2 text-base">
              <div
                class="
                  flex
                  items-center
                  space-x-2
                  cursor-pointer
                  hover:opacity-70
                  h-10
                "
                @click="downCvs"
              >
                <i class="iconfont icon-xlsx"></i>
                <div>.csv</div>
              </div>
              <div
                class="
                  flex
                  items-center
                  space-x-2
                  cursor-pointer
                  hover:opacity-70
                  h-10
                "
                @click="downJson"
              >
                <i class="iconfont icon-xiazai"> </i>
                <div>.json</div>
              </div>
            </div>
          </template>
        </tippy>

        <div
          class="
            w-9
            h-9
            rounded-full
            bg-white-005
            flex
            items-center
            justify-center
            cursor-pointer
            hover:bg-white-030
            transition-all
          "
          @click="share"
        >
          <i class="iconfont icon-fenxiang2 text-xs"></i>
        </div>
      </div>
    </div>
    <div class="flex-1 min-h-0">
      <Skeletor class="w-full h-full rounded" v-if="loading"></Skeletor>

      <div class="flex flex-col h-full" v-else>
        <img
          class="w-14"
          src="@/assets/images/icons/logo_watermark.avif"
          alt=""
        />
        <div class="flex-1 min-h-0">
          <Marketplaces :data="state.data"></Marketplaces>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Marketplaces from '@/components/Chart/Marketplaces.vue';
import { useReqByBool } from '@/hooks';
import { inject, onMounted, reactive, watch } from 'vue';
import { Skeletor } from 'vue-skeletor';
import { exportCsv, exportJson } from '@/utils/exportFile';
import { queryDaoRankRace } from '@/api/common';
import { homeChains, homeTypes } from './constant';

const curChain = inject('curChain');
const homeState = inject('homeState');

const state = reactive({
  data: [],
});

const share = () => {
  const twTittle = 'Rank： Daily Change in DAO Treasuries By @thepass_to ';
  const twUrl = `${window.location.origin}`;
  window.open(
    `https://twitter.com/intent/tweet?text=${twTittle}&url=${twUrl}`,
    '_blank',
  );
};

const formatData = (data) => {
  let res = [];
  data.forEach((x) => {
    res = [...res, ...JSON.parse(JSON.stringify(x))];
  });
  return res;
};

const downJson = () => {
  exportJson(
    formatData(state.data),
    'treasury_of_daos_per_day_change_rank_by_thepass',
  );
};

const downCvs = () => {
  exportCsv(
    formatData(state.data),
    'treasury_of_daos_per_day_change_rank_by_thepass',
  );
};

const { loading, loadData } = useReqByBool(async () => {
  const res = await queryDaoRankRace(
    homeTypes[homeState.selectedType].value,
    homeChains[homeState.selectedChain].value,
    homeState.filterStatus,
    true,
  );
  state.data = res;
});

watch(
  () => [
    homeState.selectedType,
    homeState.selectedChain,
    homeState.filterStatus,
  ],
  () => {
    loadData();
  },
);

onMounted(() => {
  loadData();
});
</script>

<style lang="scss" scoped></style>
